// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../next/Next.bs.js");
let React = require("react");
let UserSession = require("../UserSession/UserSession.bs.js");

let allowedRoutes = [
  "/client",
  "/client/account"
];

function use() {
  let router = Next.useRouter();
  let pathname = Next.Router.pathname(router);
  let clientInfo = UserSession.useClientInfoOpt();
  React.useEffect(() => {
    if (clientInfo !== undefined) {
      let exit = 0;
      let tmp = clientInfo.status;
      if (tmp === "ACCESS_REVOKED" || tmp === "AGENT_NOT_AUTHORIZED" || tmp === "ACTIVE") {
        switch (tmp) {
          case "ACTIVE" :
            break;
          case "ACCESS_REVOKED" :
          case "AGENT_NOT_AUTHORIZED" :
            exit = 1;
            break;
        }
      }
      if (exit === 1) {
        if (!allowedRoutes.some(p => p === pathname)) {
          Next.Router.replace("/client", undefined, undefined, router);
        }
      }
    }
  }, [
    clientInfo,
    pathname
  ]);
}

exports.allowedRoutes = allowedRoutes;
exports.use = use;
/* Next Not a pure module */
